import React from 'react';
import { Box, TextField, MenuItem } from '@mui/material';
import { AWS_REGIONS } from '../../../shared/constants/aws';

const NAMED_SCOPE_OPTIONS = ['global', 'regional'] as const;
const SPECIFIC_SENTINEL = '__specific__';

function isSpecificRegion(scope: string): boolean {
  return scope !== '' && !NAMED_SCOPE_OPTIONS.includes(scope as typeof NAMED_SCOPE_OPTIONS[number]);
}

interface ScopePickerProps {
  value: string;
  onChange: (value: string) => void;
}

const ScopePicker: React.FC<ScopePickerProps> = ({ value, onChange }) => {
  const specific = isSpecificRegion(value);
  const selectorValue = specific ? SPECIFIC_SENTINEL : value;

  const handleSelectorChange = (selected: string) => {
    if (selected === SPECIFIC_SENTINEL) {
      onChange(AWS_REGIONS[0].value);
    } else {
      onChange(selected);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <TextField
        label="Scope"
        value={selectorValue}
        onChange={(e) => handleSelectorChange(e.target.value)}
        fullWidth
        size="small"
        select
      >
        <MenuItem value="global">Global</MenuItem>
        <MenuItem value="regional">Regional</MenuItem>
        <MenuItem value={SPECIFIC_SENTINEL}>Specific region</MenuItem>
      </TextField>

      {specific && (
        <TextField
          label="Region"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          fullWidth
          size="small"
          select
        >
          {AWS_REGIONS.map((r) => (
            <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>
          ))}
        </TextField>
      )}
    </Box>
  );
};

export default ScopePicker;
